module.exports = __webpack_public_path__ + "img/zhangqiangfeng.23dde6c2.png";